'use client';

import { useEffect, useState } from 'react';
import { SCORE_BUCKETS } from '../lib/score';

interface Stats {
  total: number;
  avg: number | null;
  distribution: { score: number; count: number }[];
}

const BUCKETS = SCORE_BUCKETS;

export function ConnectionsDistribution({
  date,
  yourScore,
}: {
  date: string;
  yourScore: number;
}) {
  const [stats, setStats] = useState<Stats | null>(null);

  useEffect(() => {
    let alive = true;
    fetch(`/api/spot/connections/${date}/stats`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => {
        if (alive) setStats(d as Stats);
      })
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, [date]);

  if (!stats || stats.total === 0) return null;

  const countFor = (s: number) =>
    stats.distribution.find((b) => b.score === s)?.count ?? 0;
  const max = Math.max(...BUCKETS.map(countFor), 1);

  return (
    <div style={{ marginTop: 26, maxWidth: 420, marginInline: 'auto' }}>
      <div style={{ textAlign: 'center', fontWeight: 600, marginBottom: 12 }}>
        Today’s scores · {stats.total} played
        {stats.avg != null ? ` · avg ${stats.avg}` : ''}
      </div>
      {BUCKETS.map((s) => {
        const count = countFor(s);
        const pct = (count / max) * 100;
        const mine = s === yourScore;
        return (
          <div
            key={s}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 8,
              margin: '5px 0',
            }}
          >
            <span
              style={{
                width: 16,
                textAlign: 'right',
                fontWeight: 700,
                fontSize: 13,
                opacity: mine ? 1 : 0.7,
              }}
            >
              {s}
            </span>
            <div
              style={{
                flex: 1,
                background: 'var(--border-soft)',
                borderRadius: 5,
                height: 24,
                position: 'relative',
                overflow: 'hidden',
              }}
            >
              <div
                style={{
                  width: `${count > 0 ? Math.max(pct, 8) : 0}%`,
                  height: '100%',
                  borderRadius: 5,
                  background: mine ? 'var(--coral-deep)' : 'var(--coral-soft)',
                  transition: 'width 0.5s cubic-bezier(0.2, 0.7, 0.2, 1)',
                }}
              />
              <span
                style={{
                  position: 'absolute',
                  right: 8,
                  top: 0,
                  lineHeight: '24px',
                  fontSize: 12,
                  fontWeight: mine ? 700 : 400,
                  color: 'var(--fg-1)',
                }}
              >
                {count}
                {mine ? ' · you' : ''}
              </span>
            </div>
          </div>
        );
      })}
    </div>
  );
}
